import { FRAME_SCALE_LINEAR, FRAME_SCALE_LOG } from '../../constants/saxs'
import { Radio, Table } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'
import find from 'lodash/find'
import { getFileName } from '../../helpers/Saxs/SaxsGeneralHelper'

class FrameListTable extends React.Component {
  render() {
    const { frames, selectedFrames, onRowClicked } = this.props
    return (
      <Table striped hover condensed>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>
              <span> Scale : </span>
              <Radio
                checked={this.props.scale === FRAME_SCALE_LOG}
                inline
                onChange={() => this.props.onScaleChanged(FRAME_SCALE_LOG)}
              >
                Log
              </Radio>
              <Radio
                checked={this.props.scale === FRAME_SCALE_LINEAR}
                inline
                onChange={() => this.props.onScaleChanged(FRAME_SCALE_LINEAR)}
              >
                Linear
              </Radio>
            </th>
          </tr>
        </thead>
        <tbody>
          {frames.map((frame, index) => (
            <tr
              key={index}
              className={
                find(
                  selectedFrames,
                  selectedFrame => selectedFrame.frameId === frame.frameId && selectedFrame.type === frame.type
                )
                  ? 'info'
                  : null
              }
              onClick={() => onRowClicked(frame.frameId, frame.type)}
            >
              <td>
                {getFileName(frame.filePath, true)}
                {frame.discarded === true ? <span style={{ color: 'red' }}>(Discarded)</span> : null}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
}

export default FrameListTable

FrameListTable.propTypes = {
  /** frame list */
  frames: PropTypes.array,

  onScaleChanged: PropTypes.func,
  /** Callback function triggered when the user clicks a row */
  onRowClicked: PropTypes.func,

  scale: PropTypes.string,
}
